<template>
<!-- Document Wrapper
============================================= -->
<div id="wrapper">

<!-- Header
		============================================= -->
		<header id="header" class="border-bottom header-size-custom" data-sticky-shrink="false">
			<div id="header-wrap">
				<div class="container">
					<div class="header-row justify-content-lg-between">

						<!-- Logo
						============================================= -->
						<div id="logo" class="me-lg-0">
							<a href="#">
								<img src="/images/myschlogo.png" alt="MYSCH Logo">
							</a>
						</div><!-- #logo end -->

						<!-- <div class="primary-menu-trigger">
							<button class="cnvs-hamburger" type="button" title="Open Mobile Menu">
								<span class="cnvs-hamburger-box"><span class="cnvs-hamburger-inner"></span></span>
							</button>
						</div>

						<nav class="primary-menu">

							

						</nav>
                        #primary-menu end

						<nav class="primary-menu">

							<ul class="menu-container not-dark">
								<li class="menu-item"><a class="menu-link ls-1 text-uppercase" :href="$router.resolve({ name: 'Register' }).href" data-lightbox="inline"><div><i class="bi-box-arrow-in-left"></i>Register</div></a></li>
								<li class="menu-item"><a class="menu-link color ls-1 text-uppercase" :href="$router.resolve({ name: 'Login' }).href" data-lightbox="inline"><div><i class="bi-box-arrow-in-right"></i>Login</div></a></li>
							</ul>

						</nav> -->

					</div>
				</div>
			</div>
			<div class="header-wrap-clone"></div>
		</header><!-- #header end -->

<!-- Content
============================================= -->
<section id="content">

    <router-view />

</section><!-- #content end -->

<!-- Footer
============================================= -->
<footer id="footer" class="dark border-0">

    <div id="copyrights">
        <div class="container text-center">
            Copyrights MYSCH.NG 2021 - 2025 | All Rights Reserved
        </div>
    </div>

</footer><!-- #footer end -->

</div><!-- #wrapper end -->
</template>
  
<script>
  import "@/assets/landing-page/css/style.css";
  import "@/assets/landing-page/css/font-icons.css";
  import "@/assets/landing-page/css/et-line.css";
  import "@/assets/landing-page/css/onepage.css";
  import "@/assets/landing-page/css/custom.css";

   export default {
      name: 'LandingLayout',
  
      mounted() {

        // Add a class to the <body> tag when this component is mounted
        document.body.classList.add("stretched");
        // Add Google Fonts
        const l1 = document.createElement("link");
        l1.rel = "stylesheet";
        l1.href = "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,400&family=Istok+Web:wght@400;700&display=swap";
        document.head.appendChild(l1);  
          
    },
    beforeDestroy() {
        // Remove the class from the <body> tag when this component is destroyed
        document.body.classList.remove("stretched");
    },
  
    methods: {
        //
      }
  }
  
  </script>
  
  <style>
  </style>
  
  